import { useEffect } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import LoginPage from "../features/auth/loginPage";
import ForgotPasswordPage from "../features/auth/ForgotPasswordPage";
import EmailVerification from "../features/auth/EmailVerification";
import DashboardLayout from "../features/dashboard/DashboardLayout";
import ProtectedRoute from "../common/ProtectedRoute";
import ManagerDashboard from "../features/manager/managerDashboard";
import ProjectsPage from "../features/manager/projects/projectsPage";
import EpicDashboard from "../features/manager/EpicManagement/epicDashboard";
import UserStoriesPage from "../features/manager/EpicManagement/userStoryManagement/viewUserStories";
import LeaveManagement from "../features/manager/leaveManagement/leaveManagement";
import PerformanceManagement from "../features/manager/performanceManagement/performanceManagement";
import HrDashboard from "../features/hr/hrDashboard";
import AttendanceDashboard from "../features/manager/attendanceManagement/attendanceDashboard";
import LeaveRequestsManager from "../components/common/leaveRequestsManager";
import UserTasksPage from "../features/manager/EpicManagement/taskManagement/viewUserTasks";
import UserStoryDetails from "../features/manager/EpicManagement/userStoryManagement/userStoryDetails";
import UserTaskDetails from "../features/manager/EpicManagement/taskManagement/userTaskDetails";
import UserSubTaskDetails from './../features/manager/EpicManagement/subTaskManagement/userSubTaskDetails';
import EmployeeManagement from "../features/hr/employeeManagementDashboard/employeeManagement";
import NotificationsManager from "../features/notifications/notificationsManager";
import EmployeeDashboard from "../features/employee/employeeDashboard";
import MyProjectList from "../features/employee/myProjectList/myProjectList";
import MyTaskList from "../features/employee/myTaskList/myTaskList";
import TaskManagement from "../features/manager/EpicManagement/taskManagement/taskManagement";
import MyTaskDetails from "../features/employee/myTaskList/myTaskDetails";
import MyAttendance from "../components/common/myAttendance";
import MyPerformance from "../features/employee/myPerformance/myPerformance";
import MyPayroll from "../features/employee/myPayroll/myPayroll";
import EmployeeDetailsView from "../features/hr/employeeManagementDashboard/employeeDetailsView";
import HRAttendanceManagement from "../features/hr/hrAttendanceManagement/hrAttendanceManagement";
import HRLeaveManagement from "../features/hr/hrLeaveManagement/hrLeaveManagement";
import HRPerformanceDashboard from "../features/hr/hrPerformanceManagement/hrPerformanceManagement";
import HRPayrollManagement from "../features/hr/hrPayrollManagement/hrPayrollManagement";
import EmployeeAttendanceHistory from "../features/hr/hrAttendanceManagement/employeeAttendanceHistory";
import ViewPastGoals from "../features/manager/performanceManagement/goals/viewPastGoals";
import ViewAppraisal from "../features/manager/performanceManagement/appraisals/viewAppraisal";
import PastAppraisals from "../features/manager/performanceManagement/appraisals/pastAppraisals";
import ViewBandAssignment from "../features/manager/performanceManagement/performanceBandAssignment/viewBandAssignment";
import TeamLeadDashboard from "../features/TeamLead/teamLeadDashboard";
import EditProjectPage from "../features/manager/projects/updateProject";
import StoryDashboard from "../features/manager/EpicManagement/userStoryManagement/storyDashboard";
import EpicDetailsPage from "../features/manager/EpicManagement/epicDetailsPage";

const NormalizePath = () => {
    const location = useLocation();
    return <Navigate to={`${location.pathname.toLowerCase()}${location.search}`} replace />;
};

if (window.history.scrollRestoration) {
    window.history.scrollRestoration = 'manual';
}

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const RedirectEpicDashboardSubtask = () => {
    const location = useLocation();
    const id = location.pathname.split("/").pop();
    if (!id) return <Navigate to="/manager/epic-management" replace />;
    return <Navigate to={`/manager/user-subtask-details?subTaskId=${id}${location.search}`} replace />;
};

function AppRouter() {
    return (
        <>
            <ScrollToTop />
            <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/verify-email/:token" element={<EmailVerification />} />
            <Route path="/Manager/*" element={<NormalizePath />} />
            <Route path="/manager/epic-dashboard/subtask-details/:subTaskId" element={<RedirectEpicDashboardSubtask />} />

            <Route element={<ProtectedRoute />}>
                <Route path="/manager" element={<DashboardLayout />}>
                    <Route path="dashboard" element={<ManagerDashboard />} />
                    <Route path="projects">
                        <Route index element={<ProjectsPage />}/>
                        <Route path="edit" element={<EditProjectPage />} />
                    </Route>
                    <Route path="epic-management">
                        <Route index element={<EpicDashboard />} />
                        <Route path=":id" element={<EpicDetailsPage />} />
                    </Route>
                    <Route path="user-stories" element={<UserStoriesPage />} />
                    <Route path="user-story-details" element={<UserStoryDetails />} />
                    <Route path="user-tasks" element={<UserTasksPage />} />
                    <Route path="user-task-details" element={<UserTaskDetails />} />
                    <Route path="user-subtask-details" element={<UserSubTaskDetails />} />
                    <Route path="task-management" element={<TaskManagement />} />
                    <Route path="attendance-management" element={<AttendanceDashboard />} />
                    <Route path="leave-management">
                        <Route index element={<LeaveManagement/>} />
                        <Route path="manage-leave-requests" element={<LeaveRequestsManager />} />
                    </Route>
                    <Route path="performance-management" element={<PerformanceManagement />} />
                    <Route path="view-past-goals" element={<ViewPastGoals />} />
                    <Route path="view-appraisals" element={<ViewAppraisal />} />
                    <Route path="past-appraisals" element={<PastAppraisals />} />
                    <Route path="band-assignment/view" element={<ViewBandAssignment />} />
                    {/* <Route path="manage-leave-requests" element={<LeaveRequestsManager />} /> */}
                    <Route path="notifications" element={<NotificationsManager />} />
                    <Route path="stories-management" element={<StoryDashboard />} />
                </Route>
                <Route path="/hr" element={<DashboardLayout />}>
                    <Route path="dashboard" element={<HrDashboard />} />
                    <Route path="employee-management" element={<EmployeeManagement />} />
                    <Route path="employee-details" element={<EmployeeDetailsView />} />
                    <Route path="attendance-management" element={<HRAttendanceManagement />} />
                    <Route path="employee-attendance-history" element={<EmployeeAttendanceHistory />} />
                    <Route path="leave-management" element={<HRLeaveManagement />} />
                    <Route path="performance-management" element={<HRPerformanceDashboard />} />
                    <Route path="payroll-management" element={<HRPayrollManagement />} />
                    <Route path="notifications" element={<NotificationsManager />} />
                </Route>
                <Route path="/team-lead" element={<DashboardLayout />}>
                    <Route path="dashboard" element={<TeamLeadDashboard />} />
                    <Route path="projects">
                        <Route index element={<ProjectsPage />} />
                        <Route path="edit" element={<EditProjectPage />} />
                    </Route>
                    <Route path="epic-management">
                        <Route index element={<EpicDashboard />} />
                        <Route path=":id" element={<EpicDetailsPage />} />
                    </Route>
                    <Route path="stories-management" element={<StoryDashboard />} />
                    <Route path="user-stories" element={<UserStoriesPage />} />
                    <Route path="user-story-details" element={<UserStoryDetails />} />
                    <Route path="user-tasks" element={<UserTasksPage />} />
                    <Route path="user-task-details" element={<UserTaskDetails />} />
                    <Route path="user-subtask-details" element={<UserSubTaskDetails />} />
                    <Route path="task-management" element={<TaskManagement />} />
                    <Route path="attendance-management" element={<AttendanceDashboard />} />
                    <Route path="leave-management">
                        <Route index element={<LeaveManagement />} />
                        <Route path="manage-leave-requests" element={<LeaveRequestsManager />} />
                    </Route>
                    <Route path="performance-management" element={<PerformanceManagement />} />
                    {/* <Route path="manage-leave-requests" element={<LeaveRequestsManager />} /> */}
                    <Route path="notifications" element={<NotificationsManager />} />
                    <Route path="my-attendance" element={<MyAttendance />} />
                </Route>
                <Route path="/employee" element={<DashboardLayout />}>
                    <Route path="dashboard" element={<EmployeeDashboard />} />
                    <Route path="my-project-list" element={<MyProjectList />} />
                    <Route path="my-tasks" element={<MyTaskList />} />
                    <Route path="my-tasks-details" element={<MyTaskDetails />} />
                    <Route path="my-attendance" element={<MyAttendance />} />
                    <Route path="manage-leave-requests" element={<LeaveRequestsManager />} />
                    <Route path="my-performance" element={<MyPerformance />} />
                    <Route path="my-payroll" element={<MyPayroll />} />
                    <Route path="notifications" element={<NotificationsManager />} />
                </Route>
            </Route>
            <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
        </>
    );
};

export default AppRouter;

